<script>
    import {VuetablePaginationInfoMixin} from './../vuetable-2'

    export default {
        data () {
            return {
                model: this.$parent.tPerPage,
            }
        },
        mixins: [VuetablePaginationInfoMixin],
        computed: {
            paginationInfo() {
                if (this.tablePagination == null || this.tablePagination.total == 0) {
                    return this.noDataTemplate
                }

                return this.infoTemplate
                    .replace('{from}', this.tablePagination.from.formatMoney(0, ' ', ' ') || 0)
                    .replace('{to}', this.tablePagination.to.formatMoney(0, ' ', ' ') || 0)
                    .replace('{total}', this.tablePagination.total.formatMoney(0, ' ', ' ') || 0)
            },
            isPerPage() {
                return !(this.tablePagination == null || this.tablePagination.total == 0);
            },
        },
        mounted() {
            let self = this;
            this.$emitter.on('tPerPage', (eventData) => {
                self.model = eventData
            });
        },
        watch: {
            model: function (val) {
                this.$emitter.emit('tPerPage', val);
            }
        },
    }
</script>

<template>
    <div :class="['vuetable-pagination-info', css.infoClass]">
        <span v-html="paginationInfo"></span>
        <select class="per-page-dropdown" v-model="model" @change="$parent.onChangePerPage(model)" v-if="isPerPage">
            <option :value="10">10</option>
            <option :value="25">25</option>
            <option :value="50">50</option>
            <option :value="150">150</option>
            <option :value="200">200</option>
            <option :value="500">500</option>
        </select>
    </div>
</template>

<style>
    .per-page-dropdown {border: solid 1px #d0d3d8; margin-left: 20px;}
</style>
